// src/hooks/termOfPayments/useUpdateTermOfPayment.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateTermOfPayment } from "../../api/apiTermOfPayments";
import parseError from "../../utils/parseError";

const useUpdateTermOfPayment = () => {
    const queryClient = useQueryClient();

    const { mutate: updateTermOfPayments, isPending } = useMutation({
        mutationFn: ({ id, req }) => updateTermOfPayment(req, id),
        onSuccess: (res) => {
            const message = res?.message || "Term of payment updated successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["termOfPayments"] });
            queryClient.invalidateQueries({ queryKey: ["termOfPayment"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to update term of payment");
        },
    });

    return { updateTermOfPayments, isPending };
};

export default useUpdateTermOfPayment;